import {
  Dialog,
  DialogTitle,
  DialogHeader,
  DialogContent,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Workspace } from "@/types/workspaces";

interface WorkspaceNameDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  workspace: Workspace | null;
  onWorkspaceChange: (workspace: Workspace) => void;
  onSave: () => void;
}

export const WorkspaceNameDialog = ({
  open,
  onOpenChange,
  workspace,
  onWorkspaceChange,
  onSave,
}: WorkspaceNameDialogProps) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Change Name</DialogTitle>
      </DialogHeader>
      <div className="flex flex-col gap-2">
        <Input
          placeholder="Name"
          value={workspace?.name}
          onChange={e =>
            onWorkspaceChange({
              ...(workspace ?? {}),
              name: e.target.value,
            } as Workspace)
          }
        />
      </div>
      <DialogFooter>
        <Button onClick={onSave}>Save</Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
